import { cn } from '@/lib/utils'
import { User, Users } from 'lucide-react'
import type { Message } from '@core/models'

interface ChatMessageProps {
  message: Message
  guestName?: string
  userName?: string
}

export const ChatMessage = ({ message, guestName, userName }: ChatMessageProps) => {
  const isUser = !!message.user

  const timestamp = message.created 
    ? new Date(message.created).toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    : ''

  return (
    <div className={cn('flex gap-3 mb-4', isUser && 'flex-row-reverse')}>
      {/* アバター */}
      <div className={cn(
        'flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center',
        isUser ? 'bg-primary text-primary-foreground' : 'bg-muted'
      )}>
        {isUser ? (
          <User className="h-4 w-4" />
        ) : (
          <Users className="h-4 w-4" />
        )}
      </div>

      {/* メッセージ本体 */}
      <div className={cn('flex flex-col max-w-[70%]', isUser && 'items-end')}>
        {/* 送信者名 */}
        <div className={cn('text-xs text-muted-foreground mb-1', isUser && 'text-right')}>
          {isUser ? (
            <span>{userName || message.user}</span>
          ) : (
            <span>{guestName || message.guest}</span>
          )}
        </div>

        {/* メッセージバブル */}
        <div className={cn(
          'rounded-lg px-4 py-2 break-words',
          isUser 
            ? 'bg-primary text-primary-foreground' 
            : 'bg-muted'
        )}>
          <div className="whitespace-pre-wrap">{message.body}</div>
        </div>

        {/* タイムスタンプ */}
        <div className={cn('text-xs text-muted-foreground mt-1', isUser && 'text-right')}>
          {timestamp}
        </div>
      </div>
    </div>
  )
}